module.exports = __webpack_public_path__ + "img/logo-ouvidoria-topo.3e25948a.png";